// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1lWEh","requiredAsterisk":"Info_requiredAsterisk__3ypTV"};